import { render } from "./fb-list.vue?vue&type=template&id=1a7e3f20&scoped=true"
import script from "./fb-list.vue?vue&type=script&lang=js"
export * from "./fb-list.vue?vue&type=script&lang=js"

import "./fb-list.vue?vue&type=style&index=0&id=1a7e3f20&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7e3f20"]])

export default __exports__